import { CircularProgress } from '@mui/material';
import * as css from './LoadingState.css';

type LoadingStateProps = {
  size?: number;
};

export const LoadingState = ({ size = 24 }: LoadingStateProps) => {
  return (
    <div className={css.loadingState}>
      <CircularProgress size={size} />
    </div>
  );
};
